<template>
    <div class="row">
        <div class="form-group col-6">
            <label class="control-label" for="assistant_type">Assistant Type</label>
            <select id="assistant_type" v-model="assistantType" :disabled="disabletype" class="form-control"
                    name="type">
                <option v-for="(value, key) in types" :key="key" :value="key">{{ value }}</option>
            </select>
        </div>
        <div v-if="response_format === 'json_schema' && hasScenePackage !== true" class="col-12 mb-4"
             style="height: 500px;">
            <label class="control-label" for="response_format_schema">Response Format Schema</label>
            <textarea id="response_format_schema" v-model="schema" name="response_format_schema"
                      class="d-none"></textarea>
            <vue-monaco-editor
                v-model:value="schema"
                theme="vs-dark"
                language="json"
                :options="MONACO_EDITOR_OPTIONS"
            />
        </div>
        <div v-if="id && !loading && hasScenePackage !== true" class="col-12 mt-4">
            <p><strong>Attached Vector Store</strong></p>
            <ul v-if="vectors.length > 0" class="list-group mb-4">
                <li v-for="vector in vectors" :key="vector.id" class="list-group-item">
                    <button v-on:click="removeVectorStore(vector.id)" type="button"
                            class="mr-2 btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                    <a :href="`https://platform.openai.com/storage/vector_stores/${vector.id}`"
                       target="_blank">{{ vector.name }}</a>
                </li>
            </ul>
            <p v-else class="alert alert-info">No vector stores attached</p>
            <div class="form-group">
                <select id="vector-store"
                        class="form-control mb-4" name="vector-store"
                        style="width: 100%;"></select>
            </div>
            <div class="form-group">
                <label for="max_num_results" class="control-label">Max Number of Results:</label>
                <input type="number" class="form-control" name="max_num_results" min="1" max="50"
                       v-model="maxNumResults">
            </div>
            <button class="btn btn-default" type="button" v-on:click="this.attachVector">Attach Vector Store</button>
        </div>
    </div>
</template>

<script>

import {VueMonacoEditor} from '@guolao/vue-monaco-editor';

export default {
    props: [
        'id', 'vectorsp', 'schemap', 'response_formatp', 'available_vectorsp', 'typep',
        'types', 'disabletype', 'documentretrievalEnabled', 'hasScenePackage',
    ],
    components: {
        VueMonacoEditor,
    },
    data() {
        const vectorStore = this.vectorsp?.[0];
        const maxNumResults = vectorStore?.max_num_results || 20;

        return {
            assistantType: this.typep || 'feedback',
            enableDocumentRetrieval: this.documentretrievalEnabled || false,
            vectors: this.vectorsp || [],
            selectedVector: null,
            maxNumResults: maxNumResults,
            loading: true,
            schema: '',
            response_format: this.response_formatp,
            MONACO_EDITOR_OPTIONS: {
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
            },
        };
    },
    created() {
        this.schema = this.normalizeSchema(this.schemap);
    },
    methods: {
        normalizeSchema(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            if (typeof value === 'string') {
                return value;
            }
            return JSON.stringify(value, null, 2);
        },
        change(checked, meter) {
            if (!checked) {
                const num = parseInt(meter.split('-')[1]);
                // remove all meters after the meter that was unchecked
                this.meters = this.meters.filter(m => {
                    const mNum = parseInt(m.split('-')[1]);
                    return mNum < num;
                });
            }
        },
        removeVectorStore: async function (vectorId) {
            console.log(vectorId);
            this.vectors = [];
            const resp = await fetch(`/assistants/${this.id}/vector-store/clear`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
                body: JSON.stringify({vectors: this.vectors}),
            });
            const data = await resp.json();
            console.log(data);
        },
        attachVector: async function () {
            if (this.selectedVector && !this.vectors.some(item => item.id === this.selectedVector.id)) {
                // just replace vectors with the selected vector since
                // OpenAI will only allow a single vector to be attached
                this.vectors = [this.selectedVector];
                const resp = await fetch(`/assistants/${this.id}/vector-store/attach`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                    body: JSON.stringify({
                        vectors: this.vectors,
                        max_num_results: this.maxNumResults,
                    }),
                });
                const data = await resp.json();
                console.log(data);
            }
        },
        initVectorSelect: async function () {
            $(() => {
                const $selectEl = $('#vector-store');
                const data = [];
                for (const key in this.available_vectorsp) {
                    data.push({id: key, text: this.available_vectorsp[key]});
                }
                $selectEl.select2({
                    ajax: {
                        url: '/vector-stores',
                        dataType: 'json',
                        data: function (params) {
                            return {
                                search: params.term,
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data.data.map((item) => {
                                    return {id: item.vector_id, text: `${item.name} - (${item.id})`};
                                }),
                            };
                        },
                    },
                }).on('change', () => {
                    const selected = $selectEl.select2('data');
                    this.selectedVector = {id: selected[0].id, name: selected[0].text};
                });
            });
            this.loading = false;
        },
    },
    mounted() {
        this.initVectorSelect();

        // Watch for changes in response format select
        const responseFormatSelect = document.getElementById('response_format');

        if (responseFormatSelect) {
            responseFormatSelect.addEventListener('change', (e) => {
                this.response_format = e.target.value;
            });
        }
    },
};
</script>
